import  React from "react"
import { Typography, Input } from "antd"
import { BulbOutlined } from "@ant-design/icons"

const { Title, Text, Paragraph } = Typography
const { TextArea } = Input

interface RefinePromptStepProps {
  customPrompt: string
  handleCustomPromptChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

export const RefinePromptStep: React.FC<RefinePromptStepProps> = ({ customPrompt, handleCustomPromptChange }) => {
  return (
    <> 
    <div className="space-y-5 mt-2">
      <Title level={4}>Refine Your Prompt</Title>
      <Paragraph>
        Edit the prompt to be specific about the domain and type of tags you need. The more details you provide, the
        better the results.
      </Paragraph>

      <div>
        <Text>Prompt </Text>
        <TextArea
          value={customPrompt}
          onChange={handleCustomPromptChange}
          placeholder="Complete the template or Describe the tags you want to generate, these tags will be used as classifiers and will be appended as metadata for the field attributes on customer records to augment, enrich and match records...."
          autoSize={{ minRows: 5, maxRows: 10 }}
          maxLength={500}
          showCount
          className="mt-2 mb-2"
        />
        <div className="mt-4 p-2 bg-blue-50 rounded-lg border border-blue-100 border-dotted">
          <Text strong className="text-blue-700 flex items-center">
            <BulbOutlined className="mr-2" /> Pro Tip: Writing Effective Prompts
          </Text>
          <Paragraph className="mt-1 text-gray-700">
            For best results, include these elements in your prompt:
            <ul className="list-disc ml-5 mt-1 mb-0">
              <li>
                Specific <strong>industry or domain</strong> (e.g., replace INSERT YOUR INDUSTRY)
              </li>
              <li>
                Clear <strong>purpose</strong> of the tags (data classification, content management)
              </li>
              <li>
                Any <strong>examples</strong> of tags you currently use or prefer
              </li>
              <li>
                Constraints like <strong>character limits</strong> or <strong>formatting</strong>
              </li>
            </ul>
          </Paragraph>
          <Text type="secondary" className="text-xs mt-1 italic block">
            Example: Generate  data classification tags for patient records in healthcare, each under 20
            characters with clear descriptions
          </Text>
        </div>
      </div>
    </div>
    </>
  )
}
